import { Component, OnInit, Inject, HostListener, ElementRef, Renderer2, ViewChild, SimpleChange, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs';
import { RecordService } from '../../../../../services/record.service';
import { debounceTime, switchMap } from 'rxjs/operators';
import { NotificationService } from '../../../../../services/notification.service';
import { ListingService } from '../../../../../services/listing.service';
import * as _moment from 'moment';
import { get, isEmpty, map as _map, cloneDeep } from 'lodash-es';
import { LooseObject } from '../../../../../objects/loose-object';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { filled } from '../../../../utils/common';
import { AdvanceSearchboxTemplate } from '../../../../../objects/advance-searchbox';
import { AsComponent, AsConfigService } from '../../../../external-libraries/ngx-advanced-searchbox/src/public_api';
import { SearchService } from '../../../../../services/search.service';
import { LONG_DISPLAY_FIELDS, SHORT_DISPLAY_FIELDS } from '../../../listing-new/listing-new-config';
import CommonPaginationConfig from '../../../listing/common/pagination/common-pagination.component';
import { FormGroup } from '@angular/forms';
import { SearchAfter } from '../../../../../objects/elasticsearch';
import { MODULE_ID_MAPPING } from '../../../../../lists/activity';

@Component({
  selector: 'app-link-related-record',
  templateUrl: './link-related-record.component.html',
  styleUrls: ['./link-related-record.component.scss']
})
export class LinkRelatedRecordComponent implements OnInit {

  @ViewChild(AsComponent) advancedSearchboxComponent: AsComponent;

  @HostListener('window:keyup.esc') onKeyUp() {
    this.cancelDialog();
  }

  objAdvancedSearchbox: {
    model?: object
    template?: Array<object>
    form?: FormGroup
  } = {};

  strListingModule: string = '';

  strTargetModule: string = '';

  strParentId: string = '';
  strParentModule: string = '';

  arModel = {};

  arRowDisplay: [][] = [];

  arData: LooseObject[] = [];

  arSelectedRecords: LooseObject = {};

  arSubscriptions: Subscription[] = [];

  arRecordsToLink: LooseObject = {};

  bSubmitted: boolean = false;

  arSearchAfters: SearchAfter[] = [];

  objLegends: LooseObject = {};

  objPagination: LooseObject = {};

  objModuleField = {
    contracts: 'contract_id',
  };

  constructor(
    public listingService: ListingService,
    private dialogRef: MatDialogRef<LinkRelatedRecordComponent>,
    private router: Router,
    private asConfigService: AsConfigService,
    private searchService: SearchService,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private recordService: RecordService,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) {
    this.strParentId = get(this.data, 'record_id');
    this.strParentModule = get(this.data, 'record_module');

    this.strListingModule = get(this.data, 'list_module');
    this.strTargetModule = get(this.data, 'target_module');
  }

  ngOnInit() {
    this.initAdvanceSearchBox();
  }

  initAdvanceSearchBox(): void {
    this.listingService.setModule(this.strListingModule);

    this._generateModel();
    this.objAdvancedSearchbox.model = {};

    this.arSubscriptions.push(this.listingService.obvInformationFilter$.subscribe( objFilter => {
      this.objAdvancedSearchbox.model = objFilter;
    }));

    this.objAdvancedSearchbox.form = new FormGroup({});

    this.listingService.getConfig(this.strListingModule).subscribe(({template, filters, metadata}) => {

      this.setupAdvanceSearchbox(template);

      this.arSubscriptions.push(this.route.queryParams.subscribe( params => {


        if (params['filter'])  {
          this.objAdvancedSearchbox.model = JSON.parse(params['filter']);
        }

        if (params['module_search']) {
          let searchValue = Array.isArray(params['module_search']) ? params['module_search'][0] : params['module_search'];
          this.objAdvancedSearchbox.model['global_search'] = {
            'op': 'eq',
            'value': searchValue,
          }

          if (!isEmpty(this.advancedSearchboxComponent)) {
            this.advancedSearchboxComponent.searchBoxControl.setValue(
              {
                'op': 'eq',
                'label': searchValue,
                'value': searchValue,
              }
            );
          }
        }

        if (params['filter'] || params['module_search']) {
          this.getData('default');
          return;
        }

        if (params.trigger !== undefined) {
          return;
        }

        const pageNum = Math.abs(parseInt(params.page));
        if (Number.isNaN(pageNum) === false) {
          this.listingService.setCurrentPageNum(pageNum);
        }

        this.getData(Number.isNaN(pageNum) ? 'default' : 'reload', null);
      }));
    });
  }

  cancelDialog(response: boolean = false): void {
    this.dialogRef.close(response);
  }

  triggerFilter(): void{
    setTimeout(() => this.filterRecord('go'), 20);
  }

  filterRecord(strAction: string, objFilter = null, bReset: boolean = false): void {
    let numPage: number = 1;

    switch (strAction) {
      case 'prev':
        numPage = this.listingService.getCurrentPageNum() - 1;
        break;
      case 'next':
        numPage = this.listingService.getCurrentPageNum() + 1;
        break;
      case 'with_filter':
        numPage = this.listingService.getCurrentPageNum();
        break;
      default:
        numPage = 1;
        break;
    }

    if (bReset) {
      numPage = 1;
    }

    const navExtras: NavigationExtras = {
      queryParams: {
        page: numPage
      },
      replaceUrl: true,
    }

    this.router.navigate([], {
      queryParams: {
        trigger: false
      }
    }).then(() => this.router.navigate([], navExtras) );
  }

  /**
   * This method forces a change detect. This is useful
   * so we can re-use the proceess triggered on
   * change detect.
   *
   * @returns {void}
   */
  forceComponentChanges(): void {
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Check field for minimize the width
   * @param strField - Current field
   */
  checkStatusField(strField) {
    let arField = ['status', 'sync_to_accounting', 'on_hold', 'is_active', 'disable_maintenance'];
    return (typeof strField[0] != 'undefined' && arField.includes(strField[0])) ? true : false;
  }

  /**
   * For fields that need short display (width: 11%).
   * Feel free to modify as more fields may require short display fields.
   *
   * @param {string[]} arField
   *
   * @returns {boolean}
   */
  checkShortDisplayField(arField: string[] = []): boolean {
    return arField.length > 0 &&
      filled(arField[0]) &&
      get(SHORT_DISPLAY_FIELDS, this.strListingModule, []).includes(arField[0]);
  }

  /**
   * For fields that need long display (width: 25%).
   * Feel free to modify as more fields may require long display fields.
   *
   * @param {string[]} arField
   *
   * @returns {boolean}
   */
  checkLongDisplayField(arField: string[] = []): boolean {
    return arField.length > 0 &&
      filled(arField[0]) &&
      get(LONG_DISPLAY_FIELDS, this.strListingModule, []).includes(arField[0]);
  }

  generateRecordUrl(strRecordId: string, numRecordIndex: number = -1): string {
    return this.listingService.getListRecordURL(
      this.strListingModule,
      strRecordId,
      numRecordIndex,
      this.listingService.getCurrentPageNum(),
      [],
      cloneDeep(this.arSearchAfters),
      this.route
    );
  }

  ngOnChangeCheckbox(event: Event, data: object, mark_all: boolean = false): void {
    let strSelectedId = get(data, 'id', '');
    if (event.currentTarget['checked'] == true) {
      this.arRecordsToLink[strSelectedId] = data;
    } else {
      delete this.arRecordsToLink[strSelectedId];
    }
  }

  onLinkRecord(): void {
    const strParentId = get(this.objModuleField, this.strParentModule, null);
    const strListingModuleId = get(MODULE_ID_MAPPING, this.strListingModule, null);
    if (filled(this.arRecordsToLink) && strParentId && strListingModuleId) {
      this.bSubmitted = true;
      let arPayload = Object.keys(this.arRecordsToLink).map( strRecordId => {
          return {
            [strParentId]: this.strParentId,
            [strListingModuleId]: strRecordId,
          };
        });
      if (filled(arPayload)) {
        this.recordService.linkRecord(this.strTargetModule, arPayload).subscribe( response => {
          if (response.status == 200) {
            this.notificationService.notifySuccess('link_record_successfully');
            this.cancelDialog(true);
          } else {
            this.notificationService.notifySuccess('content_report_error');
            this.bSubmitted = false;
          }
        })
      } else {
        this.bSubmitted = false;
        this.notificationService.notifyWarning('please_contact_admin_for_assistance');
      }
    } else {
      this.bSubmitted = false;
      this.notificationService.notifyWarning('no_selected_record_to_link');
    }
  }

  onChangePage(page: any): void {
    let intCurrentPageName = this.listingService.getCurrentPageNum();
    if (page == 'default') {
      this.listingService.setCurrentPageNum(1)
    } else if (page == 'next') {
      this.listingService.setCurrentPageNum(intCurrentPageName+1)
    } else if (page == 'prev') {
      this.listingService.setCurrentPageNum(intCurrentPageName-1)
    } else {
      this.listingService.setCurrentPageNum(page)
    }
    this.getData('reload');
  }

  unLinkRecord(record: LooseObject): void {

  }

  async getData(strPage: string, objFilter: object = null): Promise<void> {

    await new Promise(resolve => setTimeout(resolve, 100));

    const objPagination = this.listingService.beforeFetching(strPage);

    if (objFilter != null && Object.keys(objFilter).length) {
      objPagination['objFilters'] = objFilter;
    }

    const sortParams = this.listingService.getOrderBy();
    const filterParams = this.objAdvancedSearchbox.model;
    const predefinedFilterName = objFilter === null ?
      null :
      typeof(objPagination['objFilters']) === 'object' ?
      (objPagination['objFilters']['filter_name'] !== undefined ? objPagination['objFilters']['filter_name'] : null) :
      objPagination['objFilters'] as string;

    this.listingService.fetchDataAdvanceSearch(
      objPagination['objPage'],
      this.strListingModule,
      filterParams,
      sortParams,
      predefinedFilterName,
      10,
      {},
      {
        target_table: this.strTargetModule,
        target_field: get(this.objModuleField, this.strParentModule, null),
        target_value: this.strParentId,
      }
    ).pipe(
      debounceTime(100),
    ).subscribe( response => {

      const strRelateModuleId = this.objModuleField[this.strParentModule];
      this.arRowDisplay = response['row_display'];
      this.objLegends = response['legends'];
      this.arSearchAfters = response['search_after'];
      this.arData = response['data'];

      this.listingService.bLoading = false;

      this.objPagination = new CommonPaginationConfig({
        hasNextPage: response['hasNextToken'],
        hasPrevPage: response['hasPreviousToken'],
        currentPage: response['current_page'],
        totalPage: response['last_page'],
        hasNavigation: true
      });
    });
  }

  async setupAdvanceSearchbox(template: object[]): Promise<void> {
    this.objAdvancedSearchbox.model = {};
    this.objAdvancedSearchbox.template = template;
    this.objAdvancedSearchbox.template.forEach((asTemplate: AdvanceSearchboxTemplate) => {
      if (asTemplate.domains && asTemplate.domains === 'remote') {
        this.asConfigService.customDomainsAsyncFn[asTemplate.model] = (observable, viewModel, model) => {
          return observable.pipe(
            debounceTime(400),
            switchMap((term) => {
              return this.searchService.getRemoteData(asTemplate, term);
            }),
          );
        };
      }
    });

  }

  private _generateModel(strType: string | null = null): void {
    if (strType != 'default_filter' && strType != 'saved_filter') {
      this.arModel['order_by'] = this.listingService.defaultOrderBy as any || {
        id: 'updated_at',
        sort: 'desc'
      };
    }

    this.arModel['default_filter'] = null;
    this.arModel['has_filter'] = false;
    this.arModel['filter_name'] = null;
  }
}
